var render = function render(){var _vm=this,_c=_vm._self._c;return _c('apck-table',{ref:"history_table",attrs:{"columns":_vm.history_table_cols,"actions":_vm.actions,"src":_vm.url,"actionBtnWidth":_vm.actionBtnWidth,"newStyleTable":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }